import CommonUtil from '@/common/utils/CommonUtil'
import { Component, Vue } from 'vue-property-decorator'
import Store from '@/common/utils/Store'
import SessionStorageService from '@/common/SessionStorageService'
import CommonConstants from '@/common/CommonConstants'
@Component({
  name: 'C00G1010',
  components: {}
  })
export default class C00G1010Controller extends Vue {
  /**
   * 画面要素描画後処理
   */
  mounted() {
    this.init()
  }

  /**
   * 初期処理
   */
  private init() {
    const messageError = JSON.parse(
      SessionStorageService.getItem(CommonConstants.MESSAGE_ERROR)
    )

    if (messageError && messageError.length > 0) {
      Store.setResponseErrors(messageError)
    } else {
      Store.setResponseErrors([
        {
          code: 'MSGSYSI0001',
          message: CommonUtil.getMessage('MSGSYSI0001', []),
          url: ''
        }
      ])
    }
  }

  /**
   * ログインに戻るリンク押下
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }
}
